import { render, staticRenderFns } from "./TheoryPracticeLessonAttachment.vue?vue&type=template&id=ae74628a&scoped=true&"
import script from "./TheoryPracticeLessonAttachment.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeLessonAttachment.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeLessonAttachment.vue?vue&type=style&index=0&id=ae74628a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae74628a",
  null
  
)

export default component.exports